import { Link } from "react-router-dom";
import styles from "./../PageNotFound/PageNotFound.module.scss";

const Unauthorized = () => {
    return (
        <div className={styles.container}>
            <h1 className={styles.title}>403 - Unauthorized</h1>
            <p className={styles.message}>You don't have permission to access this page.</p>

            <Link
                to="/dashboard"
                className={styles.link}
            >
                Go back home
            </Link>
        </div>
    );
};

export default Unauthorized;